import { createSlice } from '@reduxjs/toolkit'
import {
  add_credit_card_info,
  connect_to_stripe,
  get_billing_info,
  get_community_billing_info,
  update_billing_info,
  update_community_billing_info
} from '../services/billingInfoService'
import { decryptData, encryptData } from 'assets/config/AppEncryptDecryptConfig'

export const billingInfoSlice = createSlice({
  name: 'billingInfo',
  initialState: {
    billingInfo: {
      loading: false,
      user_billing_info: {}
    },
    communityBillingInfo: {
      loading: false,
      data: null
    },
    updateBillingInfo: {
      loading: false
    },
    updateCommunityBillingInfo: {
      loading: false
    },
    connectToStripe: {
      loading: false
    },
    addCreditCardInfo: {
      data: null,
      loading: false
    }
  },
  extraReducers: (builder) => {
    // Get Billing Info
    builder.addCase(get_billing_info.pending, (state) => {
      state.billingInfo.loading = true
    })
    builder.addCase(get_billing_info.fulfilled, (state, action) => {
      state.billingInfo.loading = false
      state.billingInfo.user_billing_info = action.payload?.response
    })
    builder.addCase(get_billing_info.rejected, (state) => {
      state.billingInfo.loading = false
    })

    // Get Community Billing Info
    builder.addCase(get_community_billing_info.pending, (state) => {
      state.communityBillingInfo.loading = true
    })
    builder.addCase(get_community_billing_info.fulfilled, (state, action) => {
      state.communityBillingInfo.loading = false
      state.communityBillingInfo.data = action.payload?.response
    })
    builder.addCase(get_community_billing_info.rejected, (state) => {
      state.communityBillingInfo.loading = false
    })

    // Update Billing Info
    builder.addCase(update_billing_info.pending, (state) => {
      state.updateBillingInfo.loading = true
    })

    builder.addCase(update_billing_info.fulfilled, (state) => {
      state.updateBillingInfo.loading = false

      const user_data = decryptData('user')
      const modified_user_data = { ...user_data }
      if (modified_user_data) modified_user_data.is_billing_info_updated = true
      encryptData('user', modified_user_data)
    })

    builder.addCase(update_billing_info.rejected, (state) => {
      state.updateBillingInfo.loading = false
    })

    // Update Community Billing Info
    builder.addCase(update_community_billing_info.pending, (state) => {
      state.updateCommunityBillingInfo.loading = true
    })

    builder.addCase(update_community_billing_info.fulfilled, (state) => {
      state.updateCommunityBillingInfo.loading = false
    })

    builder.addCase(update_community_billing_info.rejected, (state) => {
      state.updateCommunityBillingInfo.loading = false
    })

    // Connect to stripe
    builder.addCase(connect_to_stripe.pending, (state) => {
      state.connectToStripe.loading = true
    })

    builder.addCase(connect_to_stripe.fulfilled, (state) => {
      state.connectToStripe.loading = false
    })

    builder.addCase(connect_to_stripe.rejected, (state) => {
      state.connectToStripe.loading = false
    })

    // add credit card info
    builder.addCase(add_credit_card_info.pending, (state) => {
      state.addCreditCardInfo.loading = true
    })

    builder.addCase(add_credit_card_info.fulfilled, (state, action) => {
      state.addCreditCardInfo.loading = false
      const user_data = decryptData('user')
      const modified_user_data = { ...user_data }
      if (action?.payload?.response && action?.payload?.response?.customer && modified_user_data)
        modified_user_data.stripe_cust_token = action?.payload?.response?.customer
      encryptData('user', modified_user_data)
    })

    builder.addCase(add_credit_card_info.rejected, (state) => {
      state.addCreditCardInfo.loading = false
    })
  }
})

// Action creators are generated for each case reducer function
// export const {} = professionalInfoSlice.actions

export default billingInfoSlice.reducer
